/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { Clear, Edit, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import TextInput from "../../../components/hookForms/textField";
import messages from "../../../utils/messages";
import serviceBonificacao from "../../../services/serviceBonificacao";
import { useAuth } from "../../../context/global";
import DialogEdit from "./modal/dialogEdit";

const Bonificacao = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Cadastro - Bonificação");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        bonificacaoID: "",
        nomeCliente: "",
        instalacaoID: "",
        tipo: "",
        quantidadeBonus: "",
        quantidadeFaturas: "",
        restante: "",
        observacao: "",
        dataInicio: "",
        numeroInstalacao: "",
        dataHoraUltimaAtualizacao: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            numeroInstalacao: "",
            nomeCliente: "",
            tipo: "",
            restante: "DIFERENTE DE 0",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                minWidth: 100,
                flex: 1,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                bonificacaoID: params.row.bonificacaoID,
                                instalacaoID: params.row.instalacaoID,
                                nomeCliente: params.row.nomeCliente,
                                quantidadeBonus: params.row.quantidadeBonus,
                                quantidadeFaturas: params.row.quantidadeFaturas,
                                restante: params.row.restante,
                                observacao: params.row.observacao,
                                tipo: params.row.tipo,
                                dataInicio: params.row.dataInicio,
                                numeroInstalacao: params.row.numeroInstalacao,
                                dataHoraUltimaAtualizacao: params.row.dataHoraUltimaAtualizacao,
                            })
                        }
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "bonificacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Cliente",
                field: "nomeCliente",
                type: "string",
                minWidth: 300,
                flex: 1,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Tipo",
                field: "tipo",
                type: "string",
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Qtd Bônus",
                field: "quantidadeBonus",
                type: "number",
                headerAlign: "left",
                minWidth: 180,
                flex: 1,
                valueGetter: (params: { row: GridRowModel }) =>
                    Number(params.row.quantidadeBonus.replaceAll(".", "").replaceAll(",", ".")),
                renderCell: (params: { row: GridRowModel }) => {
                    return params.row.quantidadeBonus + (params.row.tipo === "Cota" ? " kWh" : " %");
                },
            },
            {
                headerName: "Qtd Faturas",
                field: "quantidadeFaturas",
                type: "number",
                headerAlign: "left",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Restante",
                field: "restante",
                type: "string",
                minWidth: 180,
                flex: 1,
            },
            {
                headerName: "Início",
                field: "dataInicio",
                type: "date",
                minWidth: 180,
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const tipoBonificacao = [
        { label: "Todos", value: "Todos" },
        { label: "Cota", value: "Cota" },
        { label: "Fatura", value: "Fatura" },
    ];

    const restanteOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Igual a 0", value: "IGUAL A 0" },
        { label: "Diferente de 0", value: "DIFERENTE DE 0" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        if (!filters) {
            filters = { restante: "DIFERENTE DE 0" };
        }

        serviceBonificacao
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipo: values.tipo === "Todos" ? "" : values.tipo,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <TextInput
                                                name="numeroInstalacao"
                                                label="Instalação"
                                                control={control}
                                                error={errors}
                                                maxLength={20}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <TextInput
                                                name="nomeCliente"
                                                label="Cliente"
                                                control={control}
                                                error={errors}
                                                maxLength={200}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="tipo"
                                                label="Tipo"
                                                options={tipoBonificacao}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="restante"
                                                label="Restante"
                                                options={restanteOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.bonificacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            bonificacaoID: editState.bonificacaoID,
                            instalacaoID: editState.instalacaoID,
                            nomeCliente: editState.nomeCliente,
                            quantidadeBonus: editState.quantidadeBonus,
                            quantidadeFaturas: editState.quantidadeFaturas,
                            restante: editState.restante,
                            observacao: editState.observacao,
                            tipo: editState.tipo,
                            dataInicio: editState.dataInicio,
                            numeroInstalacao: editState.numeroInstalacao,
                            dataHoraUltimaAtualizacao: editState.dataHoraUltimaAtualizacao,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                bonificacaoID: "",
                                nomeCliente: "",
                                instalacaoID: "",
                                tipo: "",
                                quantidadeBonus: "",
                                quantidadeFaturas: "",
                                restante: "",
                                observacao: "",
                                dataInicio: "",
                                numeroInstalacao: "",
                                dataHoraUltimaAtualizacao: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default Bonificacao;
